'use strict';

const siteAlert = require('schaffrath/components/alert');

/**
 * Formats product card position for the pagination display.
 * @param {number} value - Position value
 * @returns {string} Zero-padded value
 */
function padNumber(value) {
    return value < 10 ? '0' + value : String(value);
}

/**
 * Sets the active product card based on the provided index and updates pagination and navigation button states.
 * @param {jquery} $heroBanner - Hero banner component
 * @param {number} index - Target card index
 */
function setActiveCard($heroBanner, index) {
    const $cards = $heroBanner.find('.STL-card');
    const total = $cards.length;
    const boundedIndex = Math.max(0, Math.min(index, total - 1));
    const $activeCard = $cards.eq(boundedIndex);
    const progress = total > 0 ? ((boundedIndex + 1) / total) * 100 : 0;

    $cards.attr('hidden', true).removeClass('m-active');
    $activeCard.removeAttr('hidden').addClass('m-active');

    $heroBanner.find('.hero-banner_products-pagination_current').text(padNumber(boundedIndex + 1));
    $heroBanner[0].style.setProperty('--hero-progress', progress + '%');
    $heroBanner.find('.js-hero-banner-prev').prop('disabled', boundedIndex === 0);
    $heroBanner.find('.js-hero-banner-next').prop('disabled', boundedIndex === total - 1);
}

/**
 * Handles the add-to-cart action for a product card.
 * @param {jquery} $button - Clicked add-to-cart button
 */
function addToCart($button) {
    const $heroBanner = $button.closest('.hero-banner');
    const url = $heroBanner.data('add-to-cart-url');
    const pid = $button.data('pid');

    if (!url || !pid) {
        return;
    }

    $.spinner().start();

    $.ajax({
        url: url,
        method: 'POST',
        data: {
            pid: pid,
            quantity: 1
        },
        success: function (data) {
            const message = data && data.message;
            const quantityTotal = data && data.quantityTotal;
            const minicartCountOfItems = data && data.minicartCountOfItems;

            $('body').trigger('product:afterAddToCart', data);
            $('body').trigger('cart:update', data);

            if (quantityTotal != null) {
                $('.minicart-quantity').html(quantityTotal);
            }

            if (minicartCountOfItems) {
                $('.minicart-link').attr({
                    'aria-label': minicartCountOfItems,
                    title: minicartCountOfItems
                });
            }

            if (message) {
                const $cartLink = $('.minicart-link').first();

                siteAlert.show({
                    type: 'success',
                    message: message,
                    link: {
                        href: $cartLink.attr('href'),
                        text: $cartLink.attr('data-goto-cart')
                    },
                    timeout: 7000
                });
            }

            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

$(document).ready(function () {
    const $heroBanners = $('.hero-banner');

    if ($heroBanners.find('.STL-card').length > 0) {
        $('body').addClass('has-hero-banner');
    }

    $heroBanners.each(function () {
        const $heroBanner = $(this);
        const hasProducts = $heroBanner.find('.STL-card').length > 0;

        if (hasProducts) {
            setActiveCard($heroBanner, 0);
        }
    });

    $('body').on('click', '.js-hero-banner-prev, .js-hero-banner-next', function () {
        const $button = $(this);
        const $heroBanner = $button.closest('.hero-banner');
        const currentIndex = $heroBanner.find('.STL-card.m-active').index();
        const direction = $button.hasClass('js-hero-banner-next') ? 1 : -1;

        setActiveCard($heroBanner, currentIndex + direction);
    });

    $('body').on('click', 'button.STL-card_cart', function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        addToCart($(this));
    });
});
